/** プランタグ（`PlanCode[]`）のチップ DOM のみ。解析は model の `Cue.planTags` 側。 */
import { PLAN_CODE_ORDER, type PlanCode } from "../../../model/manuals/lecture_video/plan_label";

const appendPlanTags = (container: HTMLElement, tags: PlanCode[]): void => {
  if (!tags.length) {
    return;
  }

  const allPlans =
    tags.length === 3 && PLAN_CODE_ORDER.every((code) => tags.includes(code));

  const wrap = document.createElement("span");
  wrap.className = "lecture_plan_tags";

  if (allPlans) {
    const chip = document.createElement("span");
    chip.className = "lecture_plan_tag lecture_plan_tag-all";
    chip.textContent = "全プラン共通";
    wrap.appendChild(chip);
  } else {
    tags.forEach((tag) => {
      const chip = document.createElement("span");
      chip.className = `lecture_plan_tag lecture_plan_tag-${tag.toLowerCase()}`;
      chip.textContent = tag;
      wrap.appendChild(chip);
    });
  }
  container.appendChild(wrap);
};

export { appendPlanTags };
